import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import React, { createContext, useContext, useEffect, useRef } from "react";
import NaocDailyProductionStore from "../store/naocdailyproductionstore";
import { Observer, observer } from "mobx-react-lite";
import {
  Badge,
  Button,
  Divider,
  Empty,
  message,
  notification,
  Radio,
  Skeleton,
  Tooltip,
} from "antd";
import {
  ExclamationCircleOutlined,
  FileExcelOutlined,
  MonitorOutlined,
  QuestionOutlined,
  TableOutlined,
  UploadOutlined,
  ZoomInOutlined,
} from "@ant-design/icons";
import { NoData } from "../../../shared/NoData";
import moment from "moment";
import formatNumber from "accounting-js/lib/formatNumber.js";
import "../styles/naocdailyproduction.css";
import { CommandBar, SearchBox } from "@fluentui/react";
import {
  RefreshCcw,
  Edit3,
  Trash2,
  FileText,
  BarChart,
  BarChart2,
  FilePlus,
  FileMinus,
  Sliders,
  Monitor,
  Eye,
  ExternalLink,
  ZoomIn,
  ZapOff,
  Zap,
  File,
  Paperclip,
  CheckCircle,
  Layers,
  Clock,
} from "react-feather";
import { toJS } from "mobx";
import confirm from "antd/lib/modal/confirm";
import { FilterCallOut } from "../../../shared/FilterCallOut";
import PreferenceStore from "../../home/store/preferenceStore";
import ReportStore from "../../../shared/ReportStore";
import { getCurrentUser } from "../../../Utility/modules/helpers";

import RequestStore from "../approvals/store/requeststore";

const _ = require("underscore");
const Preferencestore = createContext(PreferenceStore);
const reportStoreCtx = createContext(ReportStore);
const requestStoreCtx = createContext(RequestStore);

export const ProductionGrid = observer(({ permission }) => {
  const naocDailyProductionStore = useContext(NaocDailyProductionStore);
  const preferenceStore = useContext(Preferencestore);
  const reportStore = useContext(reportStoreCtx);
  const requestStore = useContext(requestStoreCtx);

  const { fullName } = getCurrentUser();
  const prodGrid = useRef(null);
  useEffect(() => {
    async function loadproductionHistory() {
      try {
        await naocDailyProductionStore.loadProductions();
        naocDailyProductionStore.resultFromQuery = false;
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: error.message,
        });
      }
    }
    loadproductionHistory();
  }, [preferenceStore.preference]);
  const formatDigitOil = (params) => {
    const { value } = params;
    // this puts commas into the number eg 1000 goes to 1,000,
    // i pulled this from stack overflow, i have no idea how it works
    if (value) {
      return formatNumber(value, {
        precision: preferenceStore.preference.oilValuesDecimalPlaces,
        thousand: ",",
      });
    }
  };
  const formatDigitGas = (params) => {
    const { value } = params;
    // this puts commas into the number eg 1000 goes to 1,000,
    // i pulled this from stack overflow, i have no idea how it works
    if (value) {
      return formatNumber(value, {
        precision: preferenceStore.preference.gasValuesDecimalPlaces,
        thousand: ",",
      });
    }
  };
  const sortChanged = (e) => {
    e.api.refreshCells();
  };
  const gridcolumnDefs = {
    columnDefs: [
      {
        headerName: "#",
        valueGetter: "node.rowIndex + 1",
        width: 50,
        resizable: true,
        sortable: true,
        pivot: false,
      },
      {
        width: 30,
        checkboxSelection: true,
        pivot: false,
      },
      {
        width: 30,

        pivot: false,
        cellRendererFramework: (item) => {
          const antStatuses = ["default", "warning", "success", "error"];
          const submitStatuses = [
            "Not Submitted",
            "Awaiting-Approval",
            "Approved",
            "Declined",
          ];
          return (
            <div
              style={{ padding: "none!important" }}
              title={submitStatuses[item.data.approvalStatus]}
            >
              <Badge status={antStatuses[item.data.approvalStatus]} />
            </div>
          );
        },
      },
      {
        headerName: "OIL PRODUCTION (bopd)",
        headerClass: "oilheader",
        children: [
          {
            headerName: "PDY",
            field: "pdYear",
            sortable: true,
            resizable: true,
            pivot: true,

            hide: true,
            width: 80,
          },
          {
            headerName: "PDYM",
            field: "pdYearMonth",
            sortable: true,
            resizable: true,
            hide: true,
            width: 100,
          },
          {
            headerName: "Production Date",
            field: "productionDate",
            type: ["dateColumn", "nonEditableColumn"],
            sortable: true,
            resizable: true,
            width: 150,
            cellStyle: { cursor: "pointer" },

            cellRendererFramework: (props) => {
              if (!props.data) {
                return null;
              }

              return (
                <Button
                  type="link"
                  title="show production entry details"
                  onClick={async () => {
                    try {
                      requestStore.showNaocProductionDetailDialog = true;
                      await naocDailyProductionStore.getNaocDailProductionById(
                        props.data.naocDailyProductionId
                      );
                    } catch (error) {
                      notification.error({
                        message: "SPARS Feedback",
                        description: error.message,
                      });
                    }

                    //requestStore.showCommentPane = true;
                  }}
                  icon={
                    <ExternalLink
                      size={16}
                      color="gray"
                      style={{ marginRight: "5px", cursor: "pointer" }}
                    />
                  }
                >
                  <span style={{ cursor: "pointer" }}>
                    {moment(props.data?.productionDate).format(
                      preferenceStore.preference.dateFormat
                    )}
                  </span>
                </Button>
              );
            },
          },
          {
            headerName: "Land Area Metered/Adjusted",
            field: "landAreaOil",

            width: 170,
            type: "numberColumn",
            cellStyle: { textAlign: "right" },
            sortable: true,
            resizable: true,
            valueFormatter: formatDigitOil,

            //
          },
          {
            headerName: "Swamp Area Metered/Adjusted",
            field: "swampAreaOil",
            sortable: true,
            resizable: true,
            cellStyle: { textAlign: "right" },
            width: 170,
            type: "numberColumn",
            valueFormatter: formatDigitOil,
          },
          {
            headerName: "BENIBOYE Daily Metered",
            field: "beniboyeOilDailyMetered",
            sortable: true,
            resizable: true,
            cellStyle: { textAlign: "right" },
            width: 170,
            type: "numberColumn",
            valueFormatter: formatDigitOil,
          },
          {
            headerName: "Total Metered/Adjusted Production",
            field: "totalOilMeteredProd",
            sortable: true,
            resizable: true,
            cellStyle: { textAlign: "right" },
            width: 200,
            type: "numberColumn",
            valueFormatter: formatDigitOil,
          },
          {
            headerName: "Total Naoc JV Oil Produced/Evacuated",
            field: "totalOilProduced",
            sortable: true,
            resizable: true,
            cellStyle: { textAlign: "right", backgroundColor: "#ffcdd2" },
            width: 170,
            type: "numberColumn",
            valueFormatter: formatDigitOil,
          },
        ],
      },
      {
        headerName: "GAS PRODUCTION (mscf/d)",
        headerClass: "gasprodheader",
        children: [
          {
            headerName: "Land Area Gas Produced",
            field: "landAreaGas",

            cellStyle: { textAlign: "right" },
            width: 170,
            sortable: true,
            resizable: true,
            valueFormatter: formatDigitGas,
            type: "numberColumn",
          },
          {
            headerName: "Swamp Area Gas Produced",
            field: "swampAreaGas",
            sortable: true,
            resizable: true,
            cellStyle: { textAlign: "right" },
            width: 170,
            type: "numberColumn",
            valueFormatter: formatDigitGas,
          },
          {
            headerName: "Total Gas Produced",
            headerComponentParams: { menuIcon: "fa-cog" },
            field: "totalGasProduced",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#B9F6CA",
            },
            width: 170,
            type: "numberColumn",
            valueFormatter: formatDigitGas,
          },
        ],
      },
      {
        headerName: "GAS UTILIZATION (mscf/d)",
        headerClass: "gasutilheader",
        children: [
          {
            headerName: "Total Gas Flared",
            field: "totalGasFlared",
            type: "numberColumn",
            cellStyle: { textAlign: "right" },
            width: 170,
            sortable: true,
            resizable: true,
            valueFormatter: formatDigitGas,
          },
          {
            headerName: "Total Gas Internally Utilized",
            field: "totalGasInternallyUtilized",
            sortable: true,
            resizable: true,
            cellStyle: { textAlign: "right" },
            width: 170,
            type: "numberColumn",
            valueFormatter: formatDigitGas,
          },
          {
            headerName: "Gas Utilized for NGL",
            field: "gasInternallyUtilizedforNGL",
            sortable: true,
            resizable: true,
            cellStyle: { textAlign: "right" },
            width: 170,
            type: "numberColumn",
            valueFormatter: formatDigitGas,
          },
        ],
      },
      {
        headerName: "GAS EVACUATION (mscf/d)",
        headerClass: "gasevacheader",
        children: [
          {
            headerName: "Daily FuelGas To EPCL.",
            field: "dailyFuelGasToEPCL",

            cellStyle: { textAlign: "right" },
            width: 170,
            sortable: true,
            resizable: true,
            valueFormatter: formatDigitGas,
            type: "numberColumn",
            columnGroupShow: "open",
          },
          {
            headerName: "Daily Gas Delivery to RS IPP",
            field: "dailyGasDeliveryToRSIPP",
            sortable: true,
            resizable: true,
            cellStyle: { textAlign: "right" },
            width: 170,
            type: "numberColumn",
            valueFormatter: formatDigitGas,
            columnGroupShow: "open",
          },
          {
            headerName: "Daily Gas Delivery to BONNY",
            field: "dailyGasDeliveryToBonny",
            sortable: true,
            resizable: true,
            cellStyle: { textAlign: "right" },
            width: 170,
            type: "numberColumn",
            valueFormatter: formatDigitGas,
            columnGroupShow: "open",
          },
          {
            headerName: "Daily Gas Delivery to JV IPP",
            field: "dailyGasJVIPP",
            sortable: true,
            resizable: true,
            cellStyle: { textAlign: "right" },
            width: 170,
            type: "numberColumn",
            valueFormatter: formatDigitGas,
            columnGroupShow: "open",
          },
          {
            headerName: "Daily Gas To EPCL FERT PLT",
            field: "dailyGasEPCLFertPLT",
            sortable: true,
            resizable: true,
            cellStyle: { textAlign: "right" },
            width: 200,
            type: "numberColumn",
            valueFormatter: formatDigitGas,
            columnGroupShow: "open",
          },
          {
            headerName: "Total Gas Evacuated",
            field: "totalGasEvacuated",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#C8E6C9",
            },
            width: 170,
            type: "numberColumn",
            valueFormatter: formatDigitGas,
            columnGroupShow: "open",
          },
        ],
      },
      {
        headerName: "GAS INJECTION / LIFT (mscf/d)",
        headerClass: "gasinjheader",
        children: [
          {
            headerName: "OB/OB G/Plant Gas Inj./Lift",
            field: "obGpGasInj",

            cellStyle: { textAlign: "right" },
            width: 190,
            sortable: true,
            resizable: true,
            valueFormatter: formatDigitGas,
            type: "numberColumn",
          },
          {
            headerName: "Kwale G/Plant Gas Inj./Lift",
            field: "kwaleGpGasInj",
            sortable: true,
            resizable: true,
            cellStyle: { textAlign: "right" },
            width: 190,
            type: "numberColumn",
            valueFormatter: formatDigitGas,
          },
          {
            headerName: "Akri Gas To Oguta Plant",
            field: "akriGasToOGutaPlant",
            sortable: true,
            resizable: true,
            cellStyle: { textAlign: "right" },
            width: 170,
            type: "numberColumn",
            valueFormatter: formatDigitGas,
          },
          {
            headerName: "Gas Inj.Into Akri 2 at Oguta",
            field: "akriGasInjToOGutaPlant",
            sortable: true,
            resizable: true,
            cellStyle: { textAlign: "right" },
            width: 170,
            type: "numberColumn",
            valueFormatter: formatDigitGas,
          },
        ],
      },
      {
        headerName: "GAS METERS (mscf/d)",
        headerClass: "gasmeterheader",
        children: [
          {
            headerName: "Total Gas Rec. at OB/OB G/Plant",
            field: "totalGasRecOBGp",

            cellStyle: { textAlign: "right" },
            sortable: true,
            resizable: true,
            valueFormatter: formatDigitGas,
            type: "numberColumn",
          },
          {
            headerName: "Total Gas Rec. at Kwale G/Plant",
            field: "totalGasRecKwaleGp",
            sortable: true,
            resizable: true,
            cellStyle: { textAlign: "right" },
            type: "numberColumn",
            valueFormatter: formatDigitGas,
          },
        ],
      },

      {
        headerName: "NGL (bpd)",
        headerClass: "nglheader",
        children: [
          {
            headerName: "NGL Produced",
            field: "nglProduced",

            cellStyle: {
              textAlign: "right",
              backgroundColor: "#FFC107",
            },
            sortable: true,
            resizable: true,
            valueFormatter: formatDigitOil,
            type: "numberColumn",
          },
          {
            headerName: "NGL Delivered",
            field: "nglDelivered",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#FFECB3",
            },
            type: "numberColumn",
            valueFormatter: formatDigitOil,
          },
        ],
      },

      {
        headerName: "Remarks",

        children: [
          {
            headerName: "Land Area",
            field: "strippedLARemarks",
            filter: true,
            sortable: true,
            resizable: true,
            cellRendererFramework: (item) => {
              if (!item.data) {
                return null;
              }

              return (
                item.data.landAreaRemarks && (
                  <>
                    <span>
                      {" "}
                      <Button
                        type="link"
                        title="show land area field production remarks"
                        onClick={() => {
                          naocDailyProductionStore.remarkObj = {
                            title: ` ${moment(item.data?.productionDate).format(
                              preferenceStore.preference.dateFormat
                            )} Land Area  Remarks`,
                            remark: item.data.landAreaRemarks,
                          };
                          naocDailyProductionStore.showRemarkPane = true;
                        }}
                        style={{ cursor: "pointer" }}
                        icon={<ExternalLink size={16} color="gray" />}
                      ></Button>
                    </span>
                    <span>{item.data.strippedLARemarks}</span>
                  </>
                )
              );
            },
          },
          {
            headerName: "Swamp Area",
            field: "strippedSARemarks",
            sortable: true,
            resizable: true,
            filter: true,
            cellRendererFramework: (item) => {
              if (!item.data) {
                return null;
              }

              return (
                item.data.swampAreaRemarks && (
                  <>
                    <span>
                      {" "}
                      <Button
                        type="link"
                        title="show swamp area field production remarks"
                        onClick={() => {
                          naocDailyProductionStore.remarkObj = {
                            title: ` ${moment(item.data?.productionDate).format(
                              preferenceStore.preference.dateFormat
                            )} Swamp Area Remarks`,
                            remark: item.data.swampAreaRemarks,
                          };
                          naocDailyProductionStore.showRemarkPane = true;
                        }}
                        style={{ cursor: "pointer" }}
                        icon={<ExternalLink size={16} color="gray" />}
                      ></Button>
                    </span>
                    <span>{item.data.strippedSARemarks}</span>
                  </>
                )
              );
            },
          },
        ],
      },
      {
        headerName: "PRODUCTION UNITIZATIONS",
        children: [
          {
            headerName: "SPDC Akri/Oguta Share",
            field: "spdcAkriOguta",
            sortable: true,
            resizable: true,

            width: 170,
            type: "numberColumn",
            valueFormatter: formatDigitOil,
          },
          {
            headerName: "SPDC Ogbain/Afuo Share",
            field: "spdcOgbainAfuo",
            sortable: true,
            resizable: true,

            width: 170,
            type: "numberColumn",
            valueFormatter: formatDigitOil,
          },
          {
            headerName: "Spdc Samabri/Biseni Share",
            field: "spdcSamabiriBiseni",
            sortable: true,
            resizable: true,

            width: 170,
            type: "numberColumn",
            valueFormatter: formatDigitOil,
          },
          {
            headerName: "Spdc Tebidaba Unitized Share",
            field: "spdcTebidaba",
            sortable: true,
            resizable: true,

            width: 170,
            type: "numberColumn",
            valueFormatter: formatDigitOil,
          },
          {
            headerName: "Spdc Oshie Share",
            field: "spdcOshie",
            sortable: true,
            resizable: true,

            width: 170,
            type: "numberColumn",
            valueFormatter: formatDigitOil,
          },
          {
            headerName: "Pillar/Newton Unitized Share",
            field: "pillarNewton",
            sortable: true,
            resizable: true,

            width: 170,
            type: "numberColumn",
            valueFormatter: formatDigitOil,
          },
        ],
      },
      {
        headerName: "Audit",

        children: [
          {
            headerName: "Status",
            pivot: false,
            cellRendererFramework: (item) => {
              const submitStatuses = [
                "Not Submitted",
                "Awaiting-Approval",
                "Approved",
                "Declined",
              ];
              return (
                <div
                  style={{ padding: "none!important" }}
                  title={submitStatuses[item.data.approvalStatus]}
                >
                  <span>{submitStatuses[item.data.approvalStatus]}</span>
                </div>
              );
            },
          },
          {
            headerName: "Uploaded(Modified) By",
            field: "uploadedBy",
            filter: true,
            sortable: true,
            resizable: true,
          },
          {
            headerName: "Uploaded On",
            field: "uploadedOn",
            sortable: true,
            resizable: true,
            filter: true,
            cellRendererFramework: function (props) {
              return moment(props.data.uploadedOn).format(
                "ddd DD.MM.YYYY , h:mm:ss a"
              );
            },
          },
          /////REQUESTS AND APPROVALS

          {
            headerName: "Request Party",
            field: "requestor",
            filter: true,
            sortable: true,
            resizable: true,
          },
          {
            headerName: "Request Date",
            field: "",
            sortable: true,
            resizable: true,
            filter: true,
            cellRendererFramework: function (item) {
              if (item.data?.requestDate) {
                return (
                  <span title={moment(item.data.requestDate).format("LLLL")}>
                    {moment(item.data.requestDate).fromNow()}
                  </span>
                );
              } else {
                return null;
              }
            },
          },
          {
            headerName: "Approved Party",
            field: "approver",
            filter: true,
            sortable: true,
            resizable: true,
          },
          {
            headerName: "Approved Date",
            field: "",
            sortable: true,
            resizable: true,
            filter: true,
            cellRendererFramework: function (item) {
              if (item.data?.approvedDate) {
                return (
                  <span title={moment(item.data.approvedDate).format("LLLL")}>
                    {moment(item.data.approvedDate).fromNow()}
                  </span>
                );
              } else {
                return null;
              }
            },
          },
          {
            headerName: "Approver Remarks",
            field: "approverComment",
            filter: true,
            sortable: true,
            resizable: true,
          },
        ],
      },
    ],
  };
  const rowSelected = (grid) => {
    naocDailyProductionStore.disableCommand = false;
    const selrow = grid.api.getSelectedNodes()[0];

    if (selrow) {
      naocDailyProductionStore.selRow = toJS(selrow.data);
      console.log("selrow", selrow.data);
    }
    requestStore.producingDays = _.pluck(grid.api.getSelectedNodes(), "data");
    requestStore.productionGrid = grid;
    //console.log("pd", requestStore.producingDays);
  };
  const refreshData = async () => {
    try {
      let queryCriteria = {
        startDate: moment(new Date())
          .startOf("month")
          .format("YYYY-MM-DDT00:00:00.000Z"),
        endDate: moment(new Date())
          .endOf("month")
          .format("YYYY-MM-DDT00:00:00.000Z"),
        fromInception: false,
        specificDate: false,
      };
      naocDailyProductionStore.queryCriteria = queryCriteria;
      await naocDailyProductionStore.loadProductions();
      naocDailyProductionStore.gridHeaderText = `NAOC MONTHLY PRODUCTIONS from ${moment(
        queryCriteria.startDate
      ).format("ddd DD-MMM-YYYY")} to ${moment(queryCriteria.endDate).format(
        "ddd DD-MMM-YYYY"
      )}`;
      naocDailyProductionStore.resultFromQuery = false;
    } catch (error) {
      notification.error({
        message: "SPARS Feedback",
        description: error.message,
      });
    }
  };
  const refreshHandler = async () => {
    await refreshData();
  };
  return (
    <>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <CommandBar
            items={[
              {
                key: "filterte",
                onRenderIcon: () => <FilterCallOut />,
              },
              {
                key: "refresh",
                text: (
                  <Tooltip title="Refresh daily production data">
                    Refresh
                  </Tooltip>
                ),

                onRenderIcon: () => <RefreshCcw className="qicon" />,

                onClick: async () => {
                  await refreshData();
                },
              },
              {
                key: "modify",
                buttonStyles: {
                  root: { display: !permission.canUpdate ? "none" : "" },
                },
                text: (
                  <Tooltip title="Modify or edit selected daily production figures">
                    Modify
                  </Tooltip>
                ),
                disabled:
                  requestStore.producingDays.length !== 1 ||
                  naocDailyProductionStore.selRow.approvalStatus === 2,
                onRenderIcon: () => <Edit3 className="qicon" />,

                onClick: async () => {
                  if (naocDailyProductionStore.selRow) {
                    naocDailyProductionStore.initFormaData =
                      naocDailyProductionStore.selRow;
                    naocDailyProductionStore.view = "manual";
                    naocDailyProductionStore.uploadDate = moment(
                      naocDailyProductionStore.selRow.productionDate
                    );
                    naocDailyProductionStore.showNaocDailyProductionDialog = true;
                  }
                },
              },

              {
                key: "remove",
                text: (
                  <Tooltip title="Remove or delete selected daily production data with action logged ">
                    Remove
                  </Tooltip>
                ),
                name: "delete",
                buttonStyles: {
                  root: { display: !permission.canDelete ? "none" : "" },
                },
                disabled:
                  requestStore.producingDays.length !== 1 ||
                  !_.contains(
                    [0, 3],
                    naocDailyProductionStore.selRow.approvalStatus
                  ), // naocDailyProductionStore.disableCommand,
                // disabled: accountStore.userCommandBarDisabled,

                onRenderIcon: () => <Trash2 className="qicon" />,
                onClick: () => {
                  const seldata = prodGrid.current.api.getSelectedNodes()[0];
                  console.log(seldata);

                  if (!seldata) {
                    notification.info({
                      message: "SPARS Feedback",
                      description: "select production data row to remove",
                    });
                    return;
                  }

                  confirm({
                    icon: <QuestionOutlined />,
                    title: "Delete production",
                    content: (
                      <div
                        className="ms-Grid"
                        dir="ltr"
                        style={{ padding: "10px" }}
                      >
                        <div className="ms-Grid-row">
                          <div className="ms-Grid-col ms-sm12">
                            Confirm removal of production data
                          </div>
                        </div>
                        <div className="ms-Grid-row">
                          <div
                            className="ms-Grid-col ms-sm12"
                            style={{ fontStyle: "italic", padding: "10px" }}
                          >
                            <ExclamationCircleOutlined
                              style={{ color: "red" }}
                            />{" "}
                            this operation will be logged
                          </div>
                        </div>
                      </div>
                    ),
                    onOk: async () => {
                      try {
                        const seldata =
                          prodGrid.current.api.getSelectedNodes()[0];
                        const id = seldata.data.naocDailyProductionId;
                        if (id) {
                          const retVal =
                            await naocDailyProductionStore.deleteProduction(id);
                          if (retVal.success) {
                            naocDailyProductionStore.dailyProductions.delete(
                              retVal.prodId
                            );
                            message.success(
                              "Production record deleted successfully"
                            );
                          }
                        }
                      } catch (error) {
                        notification.error({
                          message: "SPARS Feedback",
                          description: error.message,
                        });
                      }
                    },
                    onCancel() {
                      console.log("Cancel");
                    },
                  });
                },
              },
              {
                key: "spacere",
                onRender: () => <div style={{ width: "25px" }} />,
              },
              {
                key: "access",

                text: (
                  <Tooltip title="perform quick query on daily production using production dates">
                    Prod.Date Query
                  </Tooltip>
                ),

                onRenderIcon: () => <ZoomIn className="qicon" />,

                onClick: () => {
                  naocDailyProductionStore.showSQeryDialog = true;
                },
              },
              {
                key: "spacer2",
                onRender: () => <div style={{ width: "25px" }} />,
              },

              {
                key: "fisc",
                onRender: () => (
                  <Tooltip title="view  production data as JV Gross (no equity factor applied) or OANDO equity share (with equity factor applied)">
                    <div
                      className="ms-Grid"
                      dir="ltr"
                      style={{ paddingTop: "10px" }}
                    >
                      <div className="ms-Grid-row">
                        <div
                          className="ms-Grid-col ms-sm1"
                          style={{ textAlign: "center" }}
                        >
                          <div
                            style={{
                              display: "inline-block",
                              marginTop: "5px",
                            }}
                          >
                            <Eye className="qicon" />
                          </div>{" "}
                        </div>
                        <div className="ms-Grid-col ms-sm11">
                          {" "}
                          <Observer>
                            {() => (
                              <Radio.Group
                                buttonStyle="solid"
                                size="small"
                                value={naocDailyProductionStore.productionview}
                                onChange={async ({ target }) => {
                                  try {
                                    naocDailyProductionStore.productionview =
                                      target.value;
                                    if (target.value === "gross") {
                                      naocDailyProductionStore.gridHeaderText = `${naocDailyProductionStore.gridHeaderText.replace(
                                        "OANDO Share",
                                        "NAOC JV(Gross)"
                                      )} `;
                                      naocDailyProductionStore.IsEquityProduction = 0;
                                    } else {
                                      naocDailyProductionStore.gridHeaderText = `${naocDailyProductionStore.gridHeaderText.replace(
                                        "NAOC JV(Gross)",
                                        "OANDO Share"
                                      )}`;
                                      naocDailyProductionStore.IsEquityProduction = 1;
                                    }
                                    await naocDailyProductionStore.loadProductions();
                                  } catch (error) {
                                    notification.error({
                                      message: "SPARS Feedback",
                                      description: error.message,
                                    });
                                  }
                                }}
                              >
                                <Radio.Button value="gross">
                                  NAOC JV Gross
                                </Radio.Button>
                                <Radio.Button value="oando">
                                  OANDO (Equity) Share
                                </Radio.Button>
                              </Radio.Group>
                            )}
                          </Observer>
                        </div>
                      </div>
                    </div>
                  </Tooltip>
                ),

                name: "access",

                onRenderIcon: () => <Sliders className="qicon" />,
                onClick: () => {
                  //prodGrid.current.api.showNoRowsOverlay()
                },
              },
              {
                key: "spacer34",
                onRender: () => <div style={{ width: "50px" }} />,
              },

              {
                key: "search",
                onRender: () => (
                  <Tooltip title="smart quick search on the production data displayed">
                    <SearchBox
                      placeholder="Search"
                      styles={{
                        root: {
                          width: "100%",
                          borderBottomColor: "#CBD5E0",
                        },
                      }}
                      underlined={true}
                      onChange={(ev, searchTerms) => {
                        prodGrid.current.api.setQuickFilter(searchTerms);
                        // const filterValue = grid.current.api.filterManager.quickFilter;
                      }}
                    ></SearchBox>
                  </Tooltip>
                ),
              },
              {
                key: "spacer3",
                onRender: () => <div style={{ width: "50px" }} />,
              },

              {
                key: "request",
                text: "Request Sign-Off",
                buttonStyles: { root: { color: "#1890ff" } },
                onRenderIcon: () => <CheckCircle className="qicon" size={32} />,
                disabled:
                  [...requestStore.producingDays.values()].length === 0 ||
                  !_.every(
                    _.pluck(requestStore.producingDays, "approvalStatus"),
                    (x) => _.contains([0, 3], x)
                  ),
                onClick: () => {
                  requestStore.showRequestDialog = true;
                  console.log(
                    "sttus",
                    _.every(
                      _.pluck(requestStore.producingDays, "approvalStatus"),
                      (x) => _.contains([0, 3], x)
                    )
                  );
                },
              },
            ]}
            farItems={[
              {
                key: "Qr1",
                onClick: () => {
                  reportStore.reportName =
                    "QikReach.Reporting.Naoc.Naoc100FlashProduction,QikReach.Reporting";
                  reportStore.showReportDialog = true;
                },
                text: (
                  <Tooltip title="generate quick NAOC daily production reports">
                    Reports
                  </Tooltip>
                ),

                onRenderIcon: () => <FileText className="qicon" />,

                ariaLabel: "New",
                subMenuProps: {
                  items: [
                    {
                      key: "sep41",
                      onRender: () => (
                        <Divider>Flash Production Reports</Divider>
                      ),
                    },
                    {
                      key: "emailMessage",
                      text: "NAOC JV(Gross) 100% Flash Report",
                      iconProps: { iconName: "" },
                      onRenderIcon: () => <FilePlus className="qicon" />,
                      onClick: () => {
                        reportStore.reportParameters = {
                          ProdStart: moment(new Date())
                            .startOf("month")
                            .toDate(),
                          ProdEndDate: moment(new Date())
                            .endOf("month")
                            .toDate(),
                        };
                        reportStore.reportName =
                          "QikReach.Reporting.Naoc.Naoc100FlashProduction,QikReach.Reporting";
                        reportStore.headerText =
                          "NAOC JV(Gross) 100% Flash production";
                        reportStore.showReportDialog = true;
                      },
                    },
                    {
                      key: "calendarEvent",
                      text: "OANDO (EQUITY) SHARE Flash Report",
                      iconProps: { iconName: "" },
                      onRenderIcon: () => <FileMinus className="qicon" />,
                      onClick: () => {
                        reportStore.reportParameters = {
                          ProdStart: moment(new Date())
                            .startOf("month")
                            .toDate(),
                          ProdEndDate: moment(new Date())
                            .endOf("month")
                            .toDate(),
                        };
                        reportStore.reportName =
                          "QikReach.Reporting.Naoc.NaocOandoEquityFlashReport,QikReach.Reporting";
                        reportStore.headerText =
                          "OANDO-NAOC Share Flash production";
                        reportStore.showReportDialog = true;
                      },
                    },
                    {
                      key: "sep45",
                      onRender: () => <Divider>OER Summary Reports</Divider>,
                    },
                    {
                      key: "oer",

                      text: (
                        <Tooltip title="OER Provisional Report">
                          OER Provisional NAOC JV Daily Production
                        </Tooltip>
                      ),
                      onRenderIcon: () => <Paperclip className="qicon" />,

                      onClick: () => {
                        let reportDate = null;
                        if (naocDailyProductionStore.selRow.productionDate) {
                          reportDate = moment(
                            naocDailyProductionStore.selRow.productionDate
                          ).add(1, "days");
                          console.log(reportDate);
                        }

                        reportStore.reportParameters = {
                          ProdDate: reportDate,
                          PreparedBy: fullName,
                        };
                        reportStore.reportName =
                          "QikReach.Reporting.Naoc.OERReport,QikReach.Reporting";
                        reportStore.headerText =
                          "OER Provisional NAOC JV Daily Production";
                        reportStore.showReportDialog = true;
                      },
                    },

                    {
                      key: "oerunrec",

                      text: (
                        <Tooltip title="OER Unreconciled Consolidated Evacuation Summary">
                          OER Unreconciled Consolidated Evacuation Summary
                        </Tooltip>
                      ),
                      onRenderIcon: () => <Monitor className="qicon" />,

                      onClick: () => {
                        let reportDate = null;
                        if (naocDailyProductionStore.selRow.productionDate) {
                          reportDate = moment(
                            naocDailyProductionStore.selRow.productionDate
                          ).add(1, "days");
                        }
                        reportStore.reportParameters = {
                          ProdDate: reportDate,
                          PreparedBy: fullName,
                        };
                        reportStore.reportName =
                          "QikReach.Reporting.Naoc.OERUnReconciledReport,QikReach.Reporting";
                        reportStore.headerText =
                          "OER Unreconciled Consolidated Evacuation Summary";
                        reportStore.showReportDialog = true;
                      },
                    },
                    {
                      key: "sep4",
                      onRender: () => <Divider></Divider>,
                    },
                    {
                      key: "integrated",

                      text: (
                        <Tooltip title="Daily Integrated Performance">
                          Daily Integrated Performance
                        </Tooltip>
                      ),
                      onRenderIcon: () => <Layers className="qicon" />,

                      onClick: () => {
                        let reportDate = null;
                        if (naocDailyProductionStore.selRow.productionDate) {
                          reportDate = moment(
                            naocDailyProductionStore.selRow.productionDate
                          ).add(1, "days");
                          console.log(reportDate);
                        }

                        reportStore.reportParameters = {
                          NaocProdDate: reportDate,
                          PreparedBy: fullName,
                        };
                        reportStore.reportName =
                          "QikReach.Reporting.Naoc.OERIntegrated,QikReach.Reporting";
                        reportStore.headerText = "Daily Integrated Performance";
                        reportStore.showReportDialog = true;
                      },
                    },
                    {
                      key: "weekly",

                      text: (
                        <Tooltip title="  Weekly  Production Performance Dashboard">
                          Weekly Production Performance Dashboard
                        </Tooltip>
                      ),
                      onRenderIcon: () => <Clock className="qicon" />,

                      onClick: () => {
                        let reportDate = null;
                        if (naocDailyProductionStore.selRow.productionDate) {
                          reportDate = moment(
                            naocDailyProductionStore.selRow.productionDate
                          ).add(1, "days");
                          console.log(reportDate);
                        }

                        reportStore.reportParameters = {
                          NaocProdDate: reportDate,
                          PreparedBy: fullName,
                        };
                        reportStore.reportName =
                          "QikReach.Reporting.WeeklyPerformance.WeeklyDashboard,QikReach.Reporting";
                        reportStore.headerText =
                          " Weekly  Production Performance Dashboard";
                        reportStore.showReportDialog = true;
                      },
                    },

                    {
                      key: "sep4",
                      onRender: () => <Divider>Commercial Reports</Divider>,
                    },
                    {
                      key: "untization",

                      text: (
                        <Tooltip title="Production Unitizations">
                          Gross Flash Production Unitizations
                        </Tooltip>
                      ),
                      onRenderIcon: () => <Zap className="qicon" />,

                      onClick: () => {
                        reportStore.reportParameters = {
                          ProdDate: null,
                          PreparedBy: fullName,
                        };
                        reportStore.reportName =
                          "QikReach.Reporting.Naoc.ProductionUnitizationGross,QikReach.Reporting";
                        reportStore.headerText =
                          "Gross Flash Production Unitizations";
                        reportStore.showReportDialog = true;
                      },
                    },
                    {
                      key: "untizatiown",

                      text: (
                        <Tooltip title="Production Unitizations">
                          OANDO Share Flash Production Unitizations
                        </Tooltip>
                      ),
                      onRenderIcon: () => <ZapOff className="qicon" />,

                      onClick: () => {
                        reportStore.reportParameters = {
                          ProdDate: null,
                          PreparedBy: fullName,
                        };
                        reportStore.reportName =
                          "QikReach.Reporting.Naoc.ProductionUnitizationEquity,QikReach.Reporting";
                        reportStore.headerText =
                          "OANDO Share Flash Production Unitizations";
                        reportStore.showReportDialog = true;
                      },
                    },
                    {
                      key: "prodsum",

                      text: (
                        <Tooltip title="POD Flash Production Summary Table">
                          &nbsp; POD Flash Production Summary Table
                        </Tooltip>
                      ),
                      onRenderIcon: () => <TableOutlined className="qicon" />,
                      subMenuProps: {
                        items: [
                          {
                            key: "emailMessage",
                            text: "As Excel",
                            onRenderIcon: () => (
                              <TableOutlined className="qicon" />
                            ),
                            onClick: () => {
                              naocDailyProductionStore.showPODExportAsExcelDialog = true;
                            },
                          },
                          {
                            key: "calendarEvent",
                            text: "As Report",
                            onRenderIcon: () => <FileText className="qicon" />,
                            onClick: () => {
                              reportStore.reportParameters = {
                                ProdDate: null,
                                PreparedBy: fullName,
                              };
                              reportStore.reportName =
                                "QikReach.Reporting.Naoc.CommercialSummary,QikReach.Reporting";
                              reportStore.headerText =
                                "OER Unreconciled Consolidated Evacuation Summary";
                              reportStore.showReportDialog = true;
                            },
                          },
                        ],
                      },

                      onClick: () => {
                        reportStore.reportParameters = {
                          ProdDate: null,
                          PreparedBy: fullName,
                        };
                        reportStore.reportName =
                          "QikReach.Reporting.Naoc.CommercialSummary,QikReach.Reporting";
                        reportStore.headerText =
                          "OER Unreconciled Consolidated Evacuation Summary";
                        reportStore.showReportDialog = true;
                      },
                    },
                    {
                      key: "flashreptsum1",

                      text: (
                        <Tooltip title="Flash Production Summary">
                          Flash Production Summary
                        </Tooltip>
                      ),
                      onRenderIcon: () => <File className="qicon" />,

                      onClick: () => {
                        reportStore.reportParameters = {
                          ProdDate: null,
                          PreparedBy: fullName,
                        };
                        reportStore.reportName =
                          "QikReach.Reporting.Naoc.CommercialFlash,QikReach.Reporting";
                        reportStore.headerText = "Flash Production Summary";
                        reportStore.showReportDialog = true;
                      },
                    },

                    {
                      key: "flashreptsum",

                      text: (
                        <Tooltip title="Aggregate Hydrocarbon Average;Sales Gas Details;Gas Distribution Analysis ">
                          Monthly Gross Totals
                        </Tooltip>
                      ),
                      onRenderIcon: () => <MonitorOutlined className="qicon" />,

                      onClick: () => {
                        reportStore.reportParameters = {
                          ProdDate: null,
                          PreparedBy: fullName,
                        };
                        reportStore.reportName =
                          "QikReach.Reporting.Naoc.MainCommaercialFlash,QikReach.Reporting";
                        reportStore.headerText = "Monthly Gross Totals";
                        reportStore.showReportDialog = true;
                      },
                    },
                  ],
                },
              },
              {
                key: "Qr",
                disabled: naocDailyProductionStore.dailyProductions.size === 0,

                onRenderIcon: () => <BarChart2 className="qicon" />,
                text: (
                  <Tooltip title="generate quick visualization for NAOC Daily Production and Evacuation Rythm">
                    Quick Viz.
                  </Tooltip>
                ),
                ariaLabel: "New",
                subMenuProps: {
                  items: [
                    {
                      key: "dopl1",
                      text: "Daily Production and Evacuation Rythm",
                      iconProps: { iconName: "" },
                      onRenderIcon: () => <BarChart className="qicon" />,
                      onClick: () => {
                        naocDailyProductionStore.openNaocOilRythmDrawer();
                      },
                    },
                  ],
                },
              },
              {
                key: "group4",
                disabled: naocDailyProductionStore.dailyProductions.size === 0,
                text: (
                  <Tooltip title="Export displayed production data to excel">
                    Export
                  </Tooltip>
                ),
                name: "group",
                onRenderIcon: () => <FileExcelOutlined className="qicon" />,

                onClick: async () => {
                  try {
                    naocDailyProductionStore.isExporting = true;
                    await prodGrid.current.api.exportDataAsExcel({
                      sheetName:
                        naocDailyProductionStore.gridHeaderText.replace(
                          "NAOC PRODUCTION",
                          "NAOCPROD"
                        ),
                      allColumns: true,

                      skipFooters: false,
                      skipGroups: false,
                      skipHeader: false,
                      skipPinnedTop: false,
                      skipPinnedBottom: false,
                      fileName: "naoc_daily_production_data",
                      columnGroups: true,
                    });
                  } catch (error) {
                    notification.error({
                      message: "SPARS Feedback",
                      description: "export failed",
                    });
                  } finally {
                    naocDailyProductionStore.isExporting = false;
                  }
                },
              },
            ]}
          />
        </div>
      </div>

      {naocDailyProductionStore.isLoading ? (
        <>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </>
      ) : (
        <div
          className="ag-theme-balham"
          style={{
            minHeight: "50vh",
            height: "65vh",
            width: "100%",
            maxHeight: "80vh",
          }}
        >
          {naocDailyProductionStore.dailyProductions.size > 0 ? (
            <AgGridReact
              rowData={[...naocDailyProductionStore.dailyProductions.values()]}
              sideBar={["columns", "filters"]}
              ref={prodGrid}
              gridOptions={{
                defaultColDef: {
                  sortable: true,
                  filter: true,
                  enableValue: true,
                  enableRowGroup: true,
                  enablePivot: true,
                },
                enableCharts: true,
                enableRangeSelection: true,

                pagination: true,
                columnDefs: gridcolumnDefs.columnDefs,
                animateRows: true,
                statusBar: {
                  statusPanels: [
                    {
                      statusPanel: "agTotalRowCountComponent",
                      align: "center",
                    },
                  ],
                },
                columnTypes: {
                  numberColumn: {
                    width: 130,
                    filter: "agNumberColumnFilter",
                  },
                  medalColumn: {
                    width: 100,
                    columnGroupShow: "open",
                    filter: false,
                  },
                  nonEditableColumn: { editable: false },
                  dateColumn: {
                    filter: "agDateColumnFilter",
                    filterParams: {
                      comparator: function (
                        filterLocalDateAtMidnight,
                        cellValue
                      ) {
                        var dateParts = cellValue.split("/");
                        var day = Number(dateParts[0]);
                        var month = Number(dateParts[1]) - 1;
                        var year = Number(dateParts[2]);
                        var cellDate = new Date(year, month, day);
                        if (cellDate < filterLocalDateAtMidnight) {
                          return -1;
                        } else if (cellDate > filterLocalDateAtMidnight) {
                          return 1;
                        } else {
                          return 0;
                        }
                      },
                    },
                  },
                },
              }}
              rowSelection="multiple"
              rowMultiSelectWithClick={true}
              onSelectionChanged={rowSelected}
              onSortChanged={sortChanged}
              copyHeadersToClipboard={true}
              overlayLoadingTemplate={`${(
                <span class="ag-overlay-loading-center">
                  Please wait while your rows are loading
                </span>
              )}`}
              overlayNoRowsTemplate={
                '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">No Result</span>'
              }
            ></AgGridReact>
          ) : naocDailyProductionStore.dailyProductions.size === 0 &&
            naocDailyProductionStore.resultFromQuery === false ? (
            <div className="ms-Grid" dir="ltr" style={{}}>
              <div className="ms-Grid-row">
                <div
                  className="ms-Grid-col ms-sm12"
                  style={{
                    height: "500px",
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <Empty
                    description={`No Productions Upload for  ${moment(
                      naocDailyProductionStore.queryCriteria.startDate
                    ).format("MMM YYYY")}`}
                  />
                  <div className="ms-Grid-row">
                    <div
                      className="ms-Grid-col ms-sm12"
                      style={{ textAlign: "center", paddingTop: "20px" }}
                    >
                      {" "}
                      {permission.canUpdate && (
                        <Button
                          type="danger"
                          icon={<UploadOutlined />}
                          onClick={() => {
                            naocDailyProductionStore.showNaocDailyProductionDialog = true;
                          }}
                        >
                          Start Production & Evacuation Upload
                        </Button>
                      )}
                    </div>
                  </div>
                  <div className="ms-Grid-row">
                    <div
                      className="ms-Grid-col ms-sm12"
                      style={{ textAlign: "center", paddingTop: "10px" }}
                    >
                      OR
                    </div>
                    <div
                      className="ms-Grid-col ms-sm12"
                      style={{ textAlign: "center", paddingTop: "10px" }}
                    >
                      <Button
                        type="link"
                        icon={<ZoomInOutlined />}
                        onClick={() => {
                          naocDailyProductionStore.showSQeryDialog = true;
                        }}
                      >
                        View previous naoc daily production upload
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <NoData
              title="No Production Record Found"
              subTitle="Sorry, No NAOC Field production record found for the selected production date"
              clickHandler={refreshHandler}
            />
          )}
        </div>
      )}
    </>
  );
});

